export const ITEM_NUMBER_BY_PAGE = 10;

export interface BasePageDto<T> {
  contents: T[];
  first: boolean;
  last: boolean;
  page: number;
  totalPages: number;
  totalElements: number;
}
